var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._g(_vm._b({tag:"component",staticClass:"align-cell",class:'align-cell-' + _vm.dir,style:({ width: _vm.width + 'px', minWidth: _vm.minWidth + 'px' })},'component',_vm.$attrs,false),_vm.$listeners),[_c('div',{ref:"div"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }